import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetAnnouncementsDetail } from "../../../../hooks/organization/notification/useGetAnnouncementsDetail";
import { useMarkAnnouncementAsRead } from "../../../../hooks/organization/notification/useMarkAnnouncementAsRead";
import { StudentNotificationDetailSkeleton } from "./StudentNotificationDetailSkeleton";
import "./StudentNotificationDetail.css";
import { useSchlStudentNotification } from "../../../context/StudentNotificationContext/SchlStudentNotificationContext";
import { useGetUnreadCount } from "../../../../hooks/organization/notification/useGetUnreadCount";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { STUDENT_ROLE_CONFIG } from "./StudentRolesTab";
import { Button } from "react-bootstrap";
import { useAuth } from "../../../context/LoginContext/AuthContext";

export const SchlStudentNotificationDetail = ({ type }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useTenantAuth();
  const { user } = useAuth();
  const role =
    type === "pcnormal" ? user?.user?.role_slug : currentUser?.role_slug;

  // console.log("my role is", role)
  const { announcement, error, getAnnouncementDetail, setAnnouncement } =
    useGetAnnouncementsDetail();
  const { setUnreadCount } = useSchlStudentNotification();
  const { getUnreadCount } = useGetUnreadCount();

  const { markAsRead } = useMarkAnnouncementAsRead();

  const [isPageReady, setIsPageReady] = useState(false);

  const handleBack = () => {
    const backRoute = STUDENT_ROLE_CONFIG[role]?.notification?.goback;
    if (backRoute) navigate(backRoute);
  };

  useEffect(() => {
    const loadData = async () => {
      setIsPageReady(false); // skeleton ON

      if (!id) return;

      // 1️⃣ DETAIL API
      const detail = await getAnnouncementDetail(id, type);

      if (detail && detail.read_at === null) {
        // 2️⃣ MARK API (WAIT HERE)
        await markAsRead(detail.id, null, { type });

        // ✅ COUNTER UPDATE
        const updatedCount = await getUnreadCount({ type });
        if (updatedCount !== null && updatedCount !== undefined) {
          setUnreadCount(updatedCount);
        }

        // optional local update
        setAnnouncement((prev) =>
          prev ? { ...prev, read_at: new Date().toISOString() } : prev,
        );
      }

      // 👇 ONLY AFTER BOTH COMPLETE
      setIsPageReady(true);
    };

    loadData();
  }, [id, type]);

  // 🎯 Skeleton until FULL process complete
  if (!isPageReady) {
    return <StudentNotificationDetailSkeleton />;
  }

  if (error) {
    return (
      <div className="container py-5 text-center text-danger">{error}</div>
    );
  }

  if (!announcement) {
    return (
      <div className="container py-5 text-center text-muted">
        Notification not found.
      </div>
    );
  }

  const isRead = !!announcement.read_at;

  return (
    <div className="notification-page">
      <div className="notification-detail-wrapper">
        <div className="notification-header">
          <div>
            <h2 className="notification-page-title">Notification Detail</h2>
            <div className="notification-subtitle">
              View announcement information
            </div>
          </div>

          <Button onClick={handleBack} className="back-btn-modern">
            ← Back
          </Button>
        </div>

        <div
          className={`notification-detail-card ${
            isRead ? "read-card" : "unread-card"
          }`}
        >
          <div className="detail-top">
            <div>
              <h3 className="detail-title">{announcement.title}</h3>

              <div className="detail-meta">
                {new Date(announcement.created_at).toLocaleString()}
              </div>
            </div>

            <span
              className={`detail-status ${
                isRead ? "status-read" : "status-unread"
              }`}
            >
              {isRead ? "Read" : "Unread"}
            </span>
          </div>

          <div className="detail-description">{announcement.description}</div>
          {/* Attachments */}
          {Array.isArray(announcement.media_url) &&
            announcement.media_url.length > 0 && (
              <div className="mt-5">
                <h6 className="attachment-title">Attachments</h6>

                <div className="attachment-container">
                  {announcement.media_url.map((file, index) => {
                    const isImage = [
                      "jpg",
                      "jpeg",
                      "png",
                      "gif",
                      "webp",
                    ].includes(file.extension?.toLowerCase());

                    const isPdf = file.extension?.toLowerCase() === "pdf";

                    return (
                      <a
                        key={index}
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="attachment-card-modern"
                      >
                        {isImage && (
                          <div className="attachment-preview">
                            <img
                              src={file.url}
                              alt={file.name}
                              className="attachment-img-modern"
                            />
                          </div>
                        )}

                        {isPdf && (
                          <div className="attachment-preview pdf-preview">
                            <div className="pdf-icon-modern">📄</div>
                            <div className="pdf-label">PDF Document</div>
                          </div>
                        )}

                        <div className="attachment-info">
                          <div className="attachment-name">
                            {file.name.length > 22
                              ? file.name.substring(0, 22) + "..."
                              : file.name}
                          </div>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
